export const UserGroups = {
  proxy: 'proxy',
  authenticated: 'authenticated',
  default: 'default',
} as const;

export type UserGroupType = typeof UserGroups[keyof typeof UserGroups];
